import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CampaignListTemplate } from 'components/Templates'

const CampaignList: FC = () => {
  return (
    <Layout headline={'キャンペーン'} iconPath={'/icon/white/cms.svg'} title={'キャンペーン一覧'}>
      <CampaignListTemplate />
    </Layout>
  )
}

export default CampaignList
